import { jwtDecode } from "jwt-decode";

export interface JwtPayload {
    exp?: number;
    iat?: number;
    sub?: string;
    [key: string]: unknown;
}

export function decodeToken(token: string): JwtPayload | null {
    try {
        return jwtDecode<JwtPayload>(token);
    } catch {
        return null;
    }
}

export function isTokenExpired(token: string): boolean {
    const payload = decodeToken(token);
    if (!payload || !payload.exp) {
        return true;
    }
    const exp = payload.exp * 1000;
    return Date.now() >= exp;
}

export function getTokenExpiry(token: string): Date | null {
    const payload = decodeToken(token);
    if (!payload || !payload.exp) {
        return null;
    }
    return new Date(payload.exp * 1000);
}

export interface MaeizJwtClaims extends JwtPayload {
    id?: string;
    role?: string;
    tenant_id?: string | null;
    jti?: string;
}

export function getTokenClaims(token: string): MaeizJwtClaims | null {
    return decodeToken(token) as MaeizJwtClaims | null;
}

export function willTokenExpireWithin(token: string, seconds: number): boolean {
    const expiry = getTokenExpiry(token);
    if (!expiry) {
        return true;
    }
    return expiry.getTime() - Date.now() <= seconds * 1000;
}
